import { z } from "zod";

// Helpers
const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalDecimal = z.coerce.number().nullable().optional(); // Para decimal(18, 2)
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalBoolean = z.boolean().nullable().optional();
const optionalDate = z.coerce.date().nullable().optional();

const regexFormatoNota = /^\d+\/\d+$/;

export const ConfigPagamentoSchema = z.object({
  IdPgtoMedicao: z.number().int().default(0),
  IdMedicaoTerceirizacao: optionalNumber,
  Nome: optionalString.pipe(z.string().max(250, "Máximo de 250 caracteres").nullable().optional()),
  AVista: optionalNumber,
  NrParcelas: optionalNumber,
  TipoData: optionalNumber,
  NroDias: optionalNumber,
  ValorTotal: optionalDecimal,
  DataPgto: optionalDate,
  IdTipoConta: optionalNumber,
  FormaPagamento: optionalString.pipe(z.string().max(250, "Máximo de 250 caracteres").nullable().optional()),
  Observacao: optionalString,
  InformacoesGerais: optionalString,
  ValorEntrada: optionalDecimal,
  DataEntrada: optionalDate,
  IdSubconta: optionalNumber,
  NrNotaFiscalEspecial: optionalString
    .transform((val) => {
      if (!val) return null;
      return val.replace(/_/g, "").trim(); 
    })
    .pipe(
      z.string()
      .max(20, "Máximo de 20 caracteres") 
      .regex(regexFormatoNota, "Formato inválido. Use o padrão: 111212121/21")
      .nullable()
      .optional()
    ),

  //Extra
  DiasEntreParcelas: optionalNumber,
  NomeFornecedor: optionalString,
});

export type ConfigPagamentoForm = z.infer<typeof ConfigPagamentoSchema>;